<template>
	<div>
		<div class="col-lg-4">
			<div class="dynvibeBox" style="min-height: 300px; max-height: 400px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Growing</h2>
					</div>
					<div class="col-lg-12">
						<ul v-if="growing.length" class="dynvibeListNoStyle">
							<li v-for="(value, index) in growing" :key="index" @click="clicked(value.key)">
								<span class="col-lg-8">{{ value.key }}</span>
								<div class="arrow-up"></div>
								<div class="col-lg-3 evolution">+{{ value.value }}%</div>
							</li>
						</ul>
						<div v-else class="noData">
							<p>No Data to display</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-4">
			<div class="dynvibeBox" style="min-height: 300px; max-height: 400px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Stable</h2>
					</div>
					<div class="col-lg-12">
						<ul v-if="stable.length" class="dynvibeListNoStyle">
							<li v-for="(value, index) in stable" :key="index" @click="clicked(value.key)">
								<span class="col-lg-8">{{ value.key }}</span>
								<div class="arrow-right"></div>
								<div class="col-lg-3 evolution">{{ (value.value >= 0 ? "+" : "") + value.value }}%</div>
							</li>
						</ul>
						<div v-else class="noData">
							<p>No Data to display</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-4">
			<div class="dynvibeBox" style="min-height: 300px; max-height: 400px">
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Declining</h2>
					</div>
					<div class="col-lg-12">
						<ul v-if="declining.length" class="dynvibeListNoStyle">
							<li v-for="(value, index) in declining" :key="index" @click="clicked(value.key)">
								<span class="col-lg-8">{{ value.key }}</span>
								<div class="arrow-down"></div>
								<div class="col-lg-3 evolution">{{ value.value }}%</div>
							</li>
						</ul>
						<div v-else class="noData">
							<p>No Data to display</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "contentgrowth",
	props: {
		type: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {};
			},
		},
		country: {
			type: Array,
			default: function () {
				return [];
			},
		},
		sources: {
			type: Array,
			default: function () {
				return [];
			},
		},
		age: {
			type: Array,
			default: function () {
				return [];
			},
		},
		gender: {
			type: Array,
			default: function () {
				return [];
			},
		},
		category: {
			type: String,
			default: "",
		},
		subcategory: {
			type: String,
			default: "",
		},
		mastertag: {
			type: String,
			default: "",
		},
		trend: {
			type: String,
			default: "",
		},
		typemastertag: {
			type: String,
			default: "All",
		},
	},
	data() {
		return {
			growing: [],
			stable: [],
			declining: [],
			evolution: {},
			loading: true,
			level: "categories",
		};
	},
	methods: {
		checkFilters() {
			this.level = "categories";
			if (this.date.gte === "") {
				return;
			}
			if (this.category != "") {
				this.level = "subcategories";
			}
			if (this.subcategory != "" || this.mastertag != "") {
				this.level = "mastertag";
			}
			if (this.trend != "") {
				this.level = "trends";
			}
			this.hidden = false;
			this.loading = true;

			this.getData("contentGrowth", {
				type: this.typemastertag,
				level: this.level,
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		clicked(item) {
			this.$emit("clicked", {
				keyword: item,
				level: this.level,
				country: "",
				date: "",
			});
		},
		loadComponent(/*parameters*/) {
			this.loading = true;
			this.getData("contentGrowth", {
				type: this.typemastertag,
				level: "categories",
				parameters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
					category: this.category,
					subcategory: this.subcategory,
					mastertag: this.mastertag,
					trend: this.trend,
					typemastertag: this.typemastertag,
					age: this.age,
					gender: this.gender,
					sources: this.sources,
				},
			});
		},
		treatResponse(response) {
			this.growing = [];
			this.declining = [];
			this.stable = [];
			this.evolution = response.data.evolution;
			for (const key in this.evolution) {
				if (this.evolution[key].profiles < -20) {
					this.declining.push({ key: key, value: this.evolution[key].profiles });
				} else if (this.evolution[key].profiles >= -20 && this.evolution[key].profiles < 40) {
					console.log(this.evolution[key].profiles);
					this.stable.push({ key: key, value: this.evolution[key].profiles });
				} else {
					this.growing.push({ key: key, value: this.evolution[key].profiles });
				}
			}
			this.growing.sort(function (a, b) {
				return b.value - a.value;
			});
			this.stable.sort(function (a, b) {
				return b.value - a.value;
			});
			this.declining.sort(function (a, b) {
				return b.value - a.value;
			});
			this.loading = false;
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
	},
};
</script>

<style scoped>
.dynvibeListNoStyle {
	list-style: none;
	font-size: 22px;
	font-weight: 300 !important;
	padding-left: 0px;
	color: #7c7c7c;
	word-break: break-all;
}

.dynvibeListNoStyle li {
	margin-bottom: 10px;
	display: -webkit-inline-box;
	width: -webkit-fill-available;
}

.dynvibeListNoStyle li:hover {
	cursor: pointer;
}

.dynvibeListNoStyle.topHashtags li:hover {
	cursor: text !important;
}

.dynvibeListNoStyle li:hover span {
	text-decoration: underline;
}

.dynvibeListNoStyle.topHashtags li:hover span {
	text-decoration: none !important;
}

.dynvibeListNoStyle li i {
	text-decoration: none !important;
	margin-right: 20px;
}
.evolution {
	font-size: 16px;
	font-weight: 700;
	color: #23056b;
	text-transform: uppercase;
	text-align: right;
	float: right;
}
.arrow-up {
	width: 0;
	height: 0;
	border-left: 15px solid transparent;
	border-right: 15px solid transparent;
	border-bottom: 15px solid green;
}

.arrow-down {
	width: 0;
	height: 0;
	border-left: 15px solid transparent;
	border-right: 15px solid transparent;
	border-top: 15px solid #f00;
}

.arrow-right {
	width: 0;
	height: 0;
	border-top: 15px solid transparent;
	border-bottom: 15px solid transparent;
	border-left: 15px solid grey;
}
</style>
